import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';

import { IncludeContent } from '../IncludeContent';
import Image from '../Image';
import { contentParser } from './helpers';
import styles from './styles.pcss';

const cx = classNames.bind(styles);

/**
 * A container for banner roulette,
 * used with JSON string content with backward compatibility with HTML content
 */

export default function IncludeBannerContent({
  className,
  htmlContent,
  isMobile,
  onClick,
  ...otherProps
}) {
  const { isJSONcontent, parsedContent } = contentParser(htmlContent);

  if (isJSONcontent && parsedContent) {
    const { background, imageMobile, imageDesktop, name, url, target } = parsedContent;

    return (
      <a
        className={cx('contentHolder')}
        data-banner-name={name}
        data-component="Link"
        href={url}
        target={target || '_self'}
        rel={target && target === '_blank' ? 'noopener noreferrer' : null}
        style={background ? { background } : null}
        onClick={onClick}
      >
        <Image
          id={name}
          src={isMobile ? imageMobile : imageDesktop}
          fallbackClassName={cx('contentFallback', isMobile && 'mobile')}
        />
      </a>
    );
  }

  return (
    <IncludeContent
      className={cx(className)}
      htmlContent={htmlContent}
      onClick={onClick}
      {...{ ...otherProps }}
    />
  );
}

IncludeBannerContent.propTypes = {
  src: PropTypes.string,
  className: PropTypes.string,
  onClick: PropTypes.func,
  /**
   * TODO: Check if isMobile prop is a best way for adaptive images or it should be moved to
   * Image component
   */
  isMobile: PropTypes.bool,
  /* Naturally it's a string with inlined HTML or JSON content */
  htmlContent: PropTypes.any,
  /* object for tunneling specific props to IncludeContent. */
  otherProps: PropTypes.object,
};
